if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	 paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false,
        infinite: true
    });

    $('.reviews').slick({
        fade: true,
        accessibility: false,
        autoplay:true
    })


    $('.sym-slides-slider').slick({
        accessibility: true,
        arrows:true,
        dots:false,
        autoplay:false,
        autoplaySpeed:1000,
        speed:1000,
        fade:true,
        appendArrows:$('.slider-block__arrows .slider-block__arrows--arrow')
    });
    
    $('.sym-amenities-mobile').slick({
        accessibility: false,
        arrows:true,
        dots:false,
        autoplay:false,
        autoplaySpeed:1000,
        speed:1000,
        fade:true,
        appendArrows:$('.amenities__arrows .amenities__arrows--arrow')
    });

    $('.sym-gallery-mobile').slick({
        accessibility: false,
        arrows:true,
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        centerPadding: '20px',
        appendArrows:$('.gallery__arrows .gallery__arrows--arrow')
    });

    $('.sym-specials').slick({
        accessibility: false,
        infinite: true,
        arrows:true,
        autoplay:true,
        autoplaySpeed:5000,
        speed:1000,
        fade:true,
    });

    document.getElementById('burgerMenu').addEventListener('click', function () {
        if (!this.classList.contains('open')) {
            this.parentElement.classList.add('open');
            this.classList.add('open');
            document.querySelector(".overlay").classList.add("open");
            document.getElementById("logo-sm").classList.remove("hidden");
            let button = document.getElementById("Close").parentElement.parentElement;
            if (button.childNodes.length == 2) {
                let newText = document.createElement("div");
                newText.textContent = "CLOSE";
                newText.classList.add("jsCloseBtn")
                button.appendChild(newText);
            }
        }
        else {
            this.classList.remove('open');
            document.getElementById("logo-sm").classList.add("hidden");
            let button = document.getElementById("Close").parentElement.parentElement;
            button.removeChild();
            this.parentElement.classList.remove('open');
            document.querySelector(".overlay").classList.remove("open");
        }
    });

    //close btn mobile
    let closeBtn = document.querySelectorAll(".nav-container")[0];
    let newButton = closeBtn.childNodes[1];
    if (newButton != undefined) {
        if (closeBtn.childNodes[1].classList.contains("mobile")) {
            let generalbutton = closeBtn.childNodes[1].children[0].children[0];
            generalbutton.addEventListener('click', function () {
                document.getElementById("logo-sm").classList.add("hidden");
                document.querySelectorAll('.overlay')[0].classList.remove('open');
                document.getElementById('burgerMenu').classList.remove('open');
            })
        }
	}

})();